/**
 * Copyright Mántum All Rights Reserved.
 */
import request from '.';
import type { Result, Headers } from '../type';

type Options = {
    body?: BodyInit | Record<string, unknown>;
    headers?: Headers;
    result?: Result;
};

export default function post<T>(url: string, options?: Options) {
    return request<T>(url, {
        body: options?.body,
        headers: options?.headers,
        method: 'POST',
        result: options?.result
    });
}
